<link
rel="stylesheet"
data-purpose="Layout StyleSheet"
title="Web Awesome"
href="/css/app-wa-86cd56275caec687041f80b17dc62e32.css?vsn=d"
>

<link
  rel="stylesheet"
  href="https://site-assets.fontawesome.com/releases/v5.15.4/css/all.css"
>
<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.5.0/font/bootstrap-icons.css">
<div class="container" [dir]="direction">
    <div class="row">
        <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12" style="top:-100px">
            <div class="ui-block"  style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                <div class="top-header">
                    <div class="top-header-thumb">
                        <img src="assets/img/top-header4.png" alt="nature" style="height: 200px;">
                    </div>
                    <div class="profile-section">
                        <div class="row">
                            <div class="col col-lg-2 col-md-2 col-sm-12 col-12">
                                <div class="top-header-author">
                                    <a routerLink="/profile" *ngIf="currentUser.success.user.role === 'president'"
                                        [ngStyle]="{'border-color':'#fff'}" class="author-thumb">
                                        <img *ngIf="!currentUser.success.user.avatar" src="assets/img/author-main1.webp"
                                            alt="author" style="width: 100%;"
                                            onerror="this.onerror=null;this.src='assets/img/author-main1.webp';"
                                            style="width: 100%; height: 120px;">
                                        <img *ngIf="currentUser.success.user.avatar" [src]="userData[0].avatar" alt="author"
                                            style="height: 120px;width: 120px;"
                                            onerror="this.onerror=null;this.src='assets/img/author-main1.webp';"
                                            style="width: 120px; height: 120px;">
                                    </a>
                                    <a routerLink="/profile" *ngIf="currentUser.success.user.role !== 'president'"
                                    [ngStyle]="{'border-color':'#fff'}" class="author-thumb">
                                        <img *ngIf="!currentUser.success.user.avatar" src="assets/img/author-main1.webp"
                                            alt="author" style="width: 100%;"
                                            onerror="this.onerror=null;this.src='assets/img/author-main1.webp';"
                                            style="width: 100%; height: 120px;">
                                        <img *ngIf="currentUser.success.user.avatar" [src]="userData[0].avatar" alt="author"
                                            style="height: 120px;width: 120px;"
                                            onerror="this.onerror=null;this.src='assets/img/author-main1.webp';"
                                            style="width: 120px; height: 120px;">
                                    </a>
                                    <div class="author-content">
                                        <a routerLink="/profile" class="h4 author-1name" style="color: var(--text-color);">{{ userData[0].fullName | titlecase }}</a>
                                        <div class="country" style="font-weight: normal; font-size: 12px; background-color: var(--backgroundpost-color); color: var(--text-color);"><i class="fad fa-globe-asia"></i> {{ userData[0].countryName | titlecase}}</div>
                                        <div class="country" *ngIf="currentUser.success.user.role == 'president'" style="font-weight: normal; font-size: 12px; color:#c9a030;"><i class="fad fa-user-tie"></i>&nbsp; {{ userData[0].role | titlecase}}</div>
                                        <div class="country" *ngIf="currentUser.success.user.role !== 'president'" style="font-weight: normal; font-size: 12px; color:#139fe0;"><i class="fad fa-flag"></i>&nbsp;{{ userData[0].role | titlecase}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col col-lg-10 col-md-10 col-sm-12 col-12">
                                <ul class="profile-menu" >
                                    <li>
                                        <a routerLink="/profile" routerLinkActive="active" style="font-size: 15px;  background-color: var(--backgroundpost-color); color: var(--text-color);"><i class="fad fa-clock"></i>&nbsp; {{'profile_header.timeline' | translate}}</a>
                                    </li>
                                    <li>
                                        <a routerLink="/about" routerLinkActive="active" style="font-size: 15px;  background-color: var(--backgroundpost-color); color: var(--text-color);"><i class="fad fa-info-circle"></i>&nbsp; {{'profile_header.about' | translate}}</a>
                                    </li>
                                    <li>
                                        <a routerLink="/friends" routerLinkActive="active" style="font-size: 15px;  background-color: var(--backgroundpost-color); color: var(--text-color);"><i class="fad fa-user-friends"></i>&nbsp;{{'profile_header.friends' | translate}}</a>
                                    </li>
                                    <li>
                                        <a routerLink="/photos" routerLinkActive="active" style="font-size: 15px;  background-color: var(--backgroundpost-color); color: var(--text-color);"><i class="fad fa-images"></i>&nbsp;{{'profile_header.photos' | translate}}</a>
                                    </li>
                                    <li>
                                        <a routerLink="/videos" routerLinkActive="active" style="font-size: 15px;  background-color: var(--backgroundpost-color); color: var(--text-color);"><i class="fad fa-video"></i>&nbsp;{{'profile_header.videos' | translate}}</a>
                                    </li>
                                    <li>
                                        <a routerLink="/followers" routerLinkActive="active" style="font-size: 15px;  background-color: var(--backgroundpost-color); color: var(--text-color);"><i class="fad fa-users"></i>&nbsp;{{'profile_header.followers' | translate}}</a>
                                    </li>
                                    <li>
                                        <a routerLink="/following" routerLinkActive="active" style="font-size: 15px;  background-color: var(--backgroundpost-color); color: var(--text-color);"><i class="fad fa-user-alt"></i>&nbsp;{{'profile_header.following' | translate}}</a>
                                    </li>
                                    <li>
                                        <div class="control-block-button">
                                            <form [formGroup]="editProfileForm" (ngSubmit)="setPhotos()">
                                                <div class="btn btn-control bg-primary more follow">
                                                    <svg class="olymp-settings-icon">
                                                        <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-settings-icon">
                                                        </use>
                                                    </svg>
                        
                                                    <ul class="more-dropdown more-with-triangle triangle-bottom-right">
                        
                                                        <li>
                        
                                                            <a href="#" data-toggle="modal" data-target="#update-header-photo">Update
                                                                Photo</a>
                                                        </li>
                                                        <li>
                                                            <a routerLink="/profile-setting">Profile Settings</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </form>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                
                
            </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="update-header-photo" tabindex="-1" role="dialog" aria-labelledby="update-header-photo"
    aria-hidden="true" >
    <div class="modal-dialog  update-header-photo" role="document">
        <div class="modal-content">
            <a routerLink="/profile" class="close icon-close" data-dismiss="modal" aria-label="Close">
                <svg class="olymp-close-icon">
                    <use xlink:href="assets/svg-icons/sprites/icons.svg#olymp-close-icon"></use>
                </svg>
            </a>

            <div class="modal-header">
                <h6 class="title">Update Photo</h6>
            </div>

            <div class="modal-body">
                <webcam [height]="50" [width]="50" class="center" [trigger]="triggerObservable"
                    (imageCapture)="handleImage($event)" *ngIf="showWebcam" [allowCameraSwitch]="allowCameraSwitch"
                    [switchCamera]="nextWebcamObservable" [videoOptions]="videoOptions"
                    (cameraSwitched)="cameraWasSwitched($event)" (initError)="handleInitError($event)">
                </webcam>
                <br />
                <div class="actionBtn text-center" (click)="triggerSnapshot();" title="Take Picture">📸
                </div>
                <div class="actionBtn text-center" (click)="showNextWebcam(true);" title="Switch Camera">🔁
                </div>

                <a class="upload-photo-item">
                    <div class="snapshot" *ngIf="webcamImage">
                        <img [src]="webcamImage.imageAsDataUrl" height="140" width="140" />
                    </div>
                    <img [src]="imgURL" height="140" width="140" *ngIf="imgURL"><br>
                    <a href="javascript:void(0);" (click)="avatar.click()" class="options-message ">
                        <img src="../assets/img/icons/gallery.png">
                    </a>
                    <form [formGroup]="editProfileForm">
                        <input style="display: none;" type="file" name="avatar" formcontrolName="avatar" #avatar
                            (change)="preview(avatar.files)">

                        <button (click)="setPhotos()" [disabled]="loading" class="btn btn-md-2 btn-primary m-3">
                            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                            Set Profile
                        </button>
                    </form>
                </a>
            </div>
        </div>
    </div>
</div>